import React, { useState } from "react";
import moment from "moment";
import "./ListsProgrammes.css";
import useFavorites from "../../../utils/useFavorites";
import { useDispatch } from "react-redux";
import {
  setSingleProgramId,
  setActiveOnglet,
  fetchProgrammes,
  addOpenProgram,
} from "../../../redux/actions/immobilierActions";
import { imageLoader } from "../../../utils/imageLoader";

const ListeProgrammes = ({ listeDesProgrammes, openNewtab = true }) => {
  const dispatch = useDispatch();
  const { favorites, isProgramInFavorites, handleAddToFavorites } =
    useFavorites();
    
  // Add state for sorting
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "desc",
  });

  const handleProgrammeClick = (programmeId) => {
    dispatch(addOpenProgram(programmeId));
    dispatch(setSingleProgramId(programmeId));
    dispatch(setActiveOnglet(`programme-${programmeId}`));
  };
  
  // Function to handle sort request
  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
    
    // Map UI keys to API field names
    let sortField = key;
    if (key === "name") {
      sortField = "name";
    } else if (key === "delivery_date") {
      sortField = "delivery_date";
    } else if (key === "is_actable") {
      sortField = "is_actable";
    }
    
    // Dispatch action to fetch sorted programmes with the direction parameter
    dispatch(fetchProgrammes(1, 25, sortField, "", direction));
  };

  // Helper function to render sort indicator
  const getSortIndicator = (key) => {
    if (sortConfig.key !== key) {
      return <img src="/icons/sorts.svg" alt="sort" className="sort-icon" />;
    }
    return sortConfig.direction === "asc" ? (
      <img
        src="/icons/sort_up.svg"
        alt="sort ascending"
        className="sort-icon"
      />
    ) : (
      <img
        src="/icons/sort_down.svg"
        alt="sort descending"
        className="sort-icon"
      />
    );
  };

  return (
    <div className="p-0">
      <div className="tableR mt-4">
        {/* Header */}
        <div className="table-programme-header pink text-center">
          <div
            className="table-cells pink semibold sortableHeaderStyle"
            onClick={() => requestSort("name")}
          >
            Programme {getSortIndicator("name")}
          </div>
          <div
            className="table-cells pink semibold sortableHeaderStyle"
            onClick={() => requestSort("delivery_date")}
          >
            Livraison {getSortIndicator("delivery_date")}
          </div>
          <div
            className="table-cells pink semibold sortableHeaderStyle"
            onClick={() => requestSort("is_actable")}
          >
            Actabilité {getSortIndicator("is_actable")}
          </div>
          <div className="table-cells pink semibold">Dispositif</div>
          <div className="table-cells pink semibold">Lots dispo.</div>
          <div className="table-cells pink semibold">Typologies</div>
          <div className="table-cells pink semibold">Prix</div>
          <div className="table-cells pink semibold">Favoris</div>
        </div>

        {/* Rows */}
        {listeDesProgrammes.map((programme) => (
          <div
            key={programme.documentId}
            className="tables-rows cursor-pointer hoverborder"
            onClick={() => handleProgrammeClick(programme.documentId)}
          >
            {/* Programme */}
            <div className="table-cells p-0">
              <div className="d-flex align-items-center gap-2 p-0">
                <div className="program-image">
                  <img
                    src={
                      programme.lots[0]?.images?.[1]?.image?.[0]?.url
                        ? imageLoader(programme.lots[0].images[1].image[0].url)
                        : programme.lots[0]?.images?.[0]?.image?.[0]?.url
                        ? imageLoader(programme.lots[0].images[0].image[0].url)
                        : "/assets/imgNotFound.webp"
                    }
                    alt="appart"
                    className="radius5"
                  />
                </div>
                <div className="d-flex flex-column text-start gap16">
                  <div>
                    <p
                      className="mb-0 fs16 darkGrey semibold name-column"
                      title={programme.name}
                    >
                      {programme.name}
                    </p>
                    <p className="text-muted mb-0 fs11 darkGrey regular">
                      {programme.address || "NC"}
                    </p>
                  </div>
                  <div>
                    <p className="mb-0 fs11 darkGrey semibold">
                      {programme.city?.name || "NC"}
                    </p>
                    <p className="text-muted mb-0 fs11 darkGrey regular">
                      {programme.delivery_date
                        ? moment(programme.delivery_date).format("YYYY") +
                          " T-" +
                          moment(programme.delivery_date).quarter()
                        : "NC"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* Livraison */}
            <div className="table-cells text-center d-flex align-items-center justify-content-center">
              {programme.delivery_date
                ? moment(programme.delivery_date).format("YYYY") +
                  " T-" +
                  moment(programme.delivery_date).quarter()
                : "NC"}
            </div>
            {/* Actabilité */}
            <div className="table-cells text-center d-flex align-items-center justify-content-center">
              {programme.is_actable ? "Immédiate" : "Pas Précisé"}
            </div>
            {/* Dispositif */}
            <div className="table-cells d-flex align-items-center justify-content-center">
              <div className="d-flex flex-column gap-2">
                <span className="badge bg-green">{"Droit commun"}</span>
                <div className="d-flex justify-content-between">
                  {["PTZ", "RP neuf"].map((badge, index) => (
                    <span
                      key={index}
                      className={`badge bg-${badge
                        .toLowerCase()
                        .replace(/\s+/g, "-")}`}
                    >
                      {badge}
                    </span>
                  ))}
                </div>
              </div>
            </div>
            {/* Lots Dispo */}
            <div className="table-cells text-center d-flex align-items-center justify-content-center">
              {programme?.lots?.length ? programme?.lots?.length : "NC"}
            </div>
            {/* Typologies */}
            <div className="table-cells text-center d-flex align-items-center justify-content-center">
              {programme.typologies || "T1-T2-T3-T4"}
            </div>
            {/* Prix */}
            <div className="table-cells d-flex align-items-center justify-content-center">
              <div className="text-center">
                {programme?.lots?.length > 0 ? (
                  <>
                    <p className="text-muted fs16 semibold darkGrey">
                      De{" "}
                      {Intl.NumberFormat("fr-FR").format(
                        programme?.lots[0]?.price_total
                      ) + " €"}
                    </p>
                    <p className="mb-0 fs16 semibold darkGrey">
                      à{" "}
                      {Intl.NumberFormat("fr-FR").format(
                        programme?.lots[programme?.lots?.length - 1]
                          ?.price_total
                      ) + " €"}
                    </p>
                  </>
                ) : (
                  "NC"
                )}
              </div>
            </div>
            {/* Action */}
            <div className="table-cells text-center d-flex align-items-center justify-content-center ">
              <img
                src={
                  isProgramInFavorites(programme.documentId)
                    ? "./icons/favorite-filled.svg"
                    : "./icons/favorite-outline.svg"
                }
                alt="favorite"
                height={35}
                width={35}
                className="cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  handleAddToFavorites(programme.documentId, "Programme");
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ListeProgrammes;